// Firebase Auth only. Firestore, Storage, Functions and RTDB are gone — the
// panel reads and writes everything through the MongoDB backend (src/api.js),
// and keeping the SDKs here would have pulled them into the bundle for nothing.
import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDz_sLPlaXhnT6LGu49M3Wl1T0pOMEUMaE",
  authDomain: "trustlive-20bd9.firebaseapp.com",
  databaseURL: "https://trustlive-20bd9-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "trustlive-20bd9",
  storageBucket: "trustlive-20bd9.appspot.com",
  messagingSenderId: "430585526443",
  appId: "1:430585526443:web:4f7d08e6a4764c8f495fee",
  measurementId: "G-4KSWLMB2C7"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export { app, auth, onAuthStateChanged, signInWithEmailAndPassword, signOut };
